import { Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import ServiceFeeModal from './ServiceFeeModal';
import ServiceFeeStore from './ServiceFeeStore';
import ServiceFeeTable from './ServiceFeeTable';
import ServiceFeeToolbar from './ServiceFeeToolbar';
import dashboardStore from '@stores/dashboard';
import * as api from '@stores/api';

@observer
class ServiceFee extends React.Component {
  componentDidMount() {
    if (!api.isAdminOrMagStaffOrAccounting()) {
      dashboardStore.close('/view/service-fee-2', true);
      return;
    }

    ServiceFeeStore.fetchService(true);
    ServiceFeeStore.fetchFiles(true);
  }
  render() {
    const { loading, loadingServiceGroup, data, open, dataServiceGroup } = ServiceFeeStore;
    return (
      <div className={`Table-${loadingServiceGroup && !data && !dataServiceGroup ? 'loading' : 'container'}`}>
        {loading && loadingServiceGroup && !dataServiceGroup ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <ServiceFeeToolbar />
            <ServiceFeeTable />
            {open && <ServiceFeeModal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default ServiceFee;
